import Link from "next/link";
import React from "react";

import PlaylistListItem from "./playlist-list-item";

type Props = {
  playlists: Playlists;
  isLoading: boolean;
};

const PlaylistList: React.FC<Props> = props => {
  const playlists = props.playlists || [];

  return (
    <div className="flex flex-col space-y-3">
      <div className="flex-shrink-0 w-px"></div>

      {playlists.map(playlist => (
        <Link href={`/playlists/${playlist.id}`} key={playlist.id}>
          <a className="">
            <PlaylistListItem playlist={playlist} />
          </a>
        </Link>
      ))}

      {props.isLoading &&
        Array.from(Array(5).keys()).map(id => (
          <div className="flex bg-gray-200 rounded-md animate-pulse" key={id}>
            <div className="w-24 h-20 bg-gray-400 rounded-l-md" />

            <div className="flex-1 px-3 py-2">
              <p className="h-4 pr-4 bg-gray-400 rounded-lg" />
              <p className="w-3/4 h-2 mt-2 bg-gray-400 rounded-lg" />
            </div>
          </div>
        ))}

      <div className="flex-shrink-0 w-px"></div>
    </div>
  );
};

export default PlaylistList;
